import { Checkbox, FormControlLabel, Stack, Typography } from "@mui/material";
import { ConfirmDialog } from "components/ConfirmDialog";
import { useState } from "react";

const ConfirmDeleteDocuments = ({
  deleteDocument,
  onClose,
  deleting,
}: {
  deleteDocument: () => Promise<void>;
  onClose: () => void;
  deleting: boolean;
}) => {
  const [confirm, setConfirm] = useState(false);

  return (
    <ConfirmDialog
      open={true}
      header="Confirm Document Delete"
      onClose={onClose}
      onConfirm={async () => {
        await deleteDocument();
        onClose();
      }}
      disableConfirm={!confirm || deleting}
      info={
        <Stack spacing={2}>
          <Typography>
            Deleting a document is a destructive action and can affect report
            submission. Please confirm with a Tier II captain or an engineer via
            #tier-2-basecamp or #engineering-support that this is safe.
          </Typography>
          <Typography>
            Please note, customer submitted documents will also appear in this
            list (like SDSs, site plans, and so on)!
          </Typography>
          <FormControlLabel
            control={
              <Checkbox
                checked={confirm}
                onChange={() => setConfirm(!confirm)}
                disabled={deleting}
              />
            }
            label={
              <Typography>
                I understand the risks and would like to delete this document
              </Typography>
            }
          />
        </Stack>
      }
    />
  );
};

export { ConfirmDeleteDocuments };
